import ApiService from "@/core/services/api/v2/api.service";

const ADDRESS_LIST_KEY = "AddressList";
const ADDRESS_FILTER_KEY = "AddressFilter";

const AddressService = {
  getProfile(addressID) {
    return new Promise(resolve => {
      ApiService.get("address/" + addressID)
        .then(response => {
          resolve(response.data.response);
        })
        .catch(error => {
          resolve(error.response.status);
        });
    });
  },

  updateProfile(addressID, newData) {
    return new Promise(resolve => {
      ApiService.put("address/" + addressID, newData)
        .then(response => {
          this.cleanCachedList();
          resolve(response.status);
        })
        .catch(error => {
          resolve(error.response.status);
        });
    });
  },

  deleteProfile(addressID) {
    return new Promise(resolve => {
      ApiService.delete("address/" + addressID)
        .then(response => {
          this.cleanCachedList();
          resolve(response.status);
        })
        .catch(error => {
          resolve(error.response.status);
        });
    });
  },

  createProfile(newData) {
    return new Promise(resolve => {
      ApiService.post("address", newData)
        .then(response => {
          this.cleanCachedList();
          // Response (if correct) holds the new AddressID
          resolve(response.data.response);
        })
        .catch(error => {
          resolve(error.response.status);
        });
    });
  },

  search(
    searchText,
    filterByProvinceID,
    filterByAddressTypeID,
    orderBy,
    orderDesc,
    limit,
    offset
  ) {
    return new Promise(resolve => {
      // Parse params - storing a cache of the filters applied
      const queryParams = {};

      searchText = searchText.trim();
      if (searchText.length > 0) {
        queryParams.Search = searchText;
      }

      filterByProvinceID = parseInt(filterByProvinceID);
      if (!isNaN(filterByProvinceID) && filterByProvinceID > 0) {
        queryParams.ProvinceID = filterByProvinceID;
      }

      filterByAddressTypeID = parseInt(filterByAddressTypeID);
      if (!isNaN(filterByAddressTypeID) && filterByAddressTypeID > 0) {
        queryParams.AddressTypeID = filterByAddressTypeID;
      }

      window.sessionStorage.setItem(
        ADDRESS_FILTER_KEY,
        JSON.stringify(queryParams)
      );

      orderBy = orderBy ? orderBy.trim() : "";
      if (orderBy.length > 0) {
        queryParams.OrderBy = orderBy;
      }

      queryParams.OrderDesc = orderDesc ? 1 : 0;

      limit = parseInt(limit);
      if (!isNaN(limit) && limit > 0) {
        queryParams.Limit = limit;
      }

      offset = parseInt(offset);
      if (!isNaN(offset)) {
        queryParams.Offset = offset;
      }

      // Do search
      ApiService.query("address", { params: queryParams })
        .then(response => {
          // Return full response, not just "Addresses" array, for pagination etc
          resolve(response.data);
        })
        .catch(() => {
          resolve(404);
        });
    });
  },

  getCachedFilters() {
    let cachedFilters = window.sessionStorage.getItem(ADDRESS_FILTER_KEY);
    if (cachedFilters) {
      return JSON.parse(cachedFilters);
    } else {
      return {};
    }
  },

  listAll(avoidCache) {
    return new Promise(resolve => {
      // This list is widely used and changes rarely, so cache its values
      let cachedList = window.sessionStorage.getItem(ADDRESS_LIST_KEY);
      if (cachedList && !avoidCache) {
        resolve(JSON.parse(cachedList));
      } else {
        ApiService.query("address", { params: { Limit: 999 } })
          .then(response => {
            let newList = response.data.response.Addresses;

            window.sessionStorage.setItem(
              ADDRESS_LIST_KEY,
              JSON.stringify(newList)
            );

            resolve(newList);
          })
          .catch(() => {
            resolve([]);
          });
      }
    });
  },

  cleanCachedList() {
    window.sessionStorage.removeItem(ADDRESS_LIST_KEY);
  }
};

export default AddressService;
